import type { ISerialize } from '@/objects/ISerialize';
import { TypeAheadItem } from './TypeAheadItem';

export class TypeAheadResponse implements ISerialize {
    public Items: TypeAheadItem[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Items?: TypeAheadItem[] }) {
        this.Items = values.Items ?? [];
    }

    public serialize(): string {
        return '{' + `"Items": [ ${this.Items.map((x) => (!x ? null : x?.serialize()))} ]` + '}';
    }

    /**
     * Creates an instance of TypeAheadResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Items?: TypeAheadItem[] }): TypeAheadResponse {
        return new TypeAheadResponse(values);
    }

    public static _FromServerJson(json: any): TypeAheadResponse {
        return new TypeAheadResponse({ Items: json.Items?.map((x: any) => TypeAheadItem._FromServerJson(x)) });
    }

    /**
     * Creates an instance of TypeAheadResponse from another instance of TypeAheadResponse.
     * @param other The TypeAheadResponse you want to clone
     * @returns A cloned TypeAheadResponse
     */
    public static FromOther(other: TypeAheadResponse): TypeAheadResponse {
        return TypeAheadResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TypeAheadResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'TypeAheadResponse';
}
